<rt-dialog-header [heading]="'tlc.members.add_member.heading' | translate" />
<rt-dialog-body variant="white">
  <form [formGroup]="formGroup" class="dialog-content">
    <span>{{ 'tlc.members.add_member.subheading' | translate }}</span>
    <div formArrayName="members" class="dialog-form">
      @for (item of members; track item.getRawValue()) {
        <div class="details-item" [formGroupName]="$index">
          <rt-form-field [hideRequiredBadge]="!$first" class="email-field">
            @if ($first) {
              <rt-label>{{ 'tlc.members.add_member.form.email' | translate }}</rt-label>
            }
            <rt-input
              [rtFormError]="emailFieldErrors"
              [placeholder]="'tlc.members.add_member.form.email_placeholder' | translate"
              formControlName="email"
              type="email"
              rtProtectedControl
            />
          </rt-form-field>
          <rt-form-field class="first-name">
            @if ($first) {
              <rt-label>{{ 'tlc.members.add_member.form.first_name' | translate }}</rt-label>
            }
            <rt-input
              [placeholder]="'tlc.members.add_member.form.first_name_placeholder' | translate"
              formControlName="firstName"
              rtProtectedControl
              [disabled]="!!item.controls.email.getError('existingMember')"
            />
          </rt-form-field>
          <rt-form-field class="last-name">
            @if ($first) {
              <rt-label>{{ 'tlc.members.add_member.form.last_name' | translate }}</rt-label>
            }
            <rt-input
              [placeholder]="'tlc.members.add_member.form.last_name_placeholder' | translate"
              formControlName="lastName"
              rtProtectedControl
              [disabled]="!!item.controls.email.getError('existingMember')"
            />
          </rt-form-field>
          @if (members.length > 1) {
            <rt-form-field>
              <rt-label></rt-label>
              <rt-icon-button
                (click)="removeMemberFormGroup($index)"
                iconName="close"
                variant="plain"
                class="remove-form-group-button"
              />
            </rt-form-field>
          }
        </div>

        @if (item.controls.email.getError('existingMember')) {
          <tl-existing-member-info
            [member]="item.controls.email.getError('existingMember')"
            [canEditAccess]="canMangeTellentUsers"
            (editAccess)="editAccess($event)"
          />
        }
      }
    </div>
    <div class="add-button-wrap">
      <rt-button
        [disabled]="formGroup.invalid || !canAddRow()"
        (click)="addMemberFormGroup()"
        variant="plain"
      >
        <rt-icon name="add" />
        <span>{{ 'tlc.members.add_member.form.add_next' | translate }}</span>
      </rt-button>
    </div>

    @switch (dialogVariant()) {
      @case (DialogVariant.Simplified) {
        <ng-container *ngTemplateOutlet="simpleViewTpl" />
      }
      @case (DialogVariant.Complex) {
        <ng-container *ngTemplateOutlet="complexViewTpl" />
      }
    }
    <div class="send-invitation">
      <rt-checkbox formControlName="sendInvitation" rtProtectedControl
        ><strong>{{ 'tlc.members.add_member.form.send_invitation' | translate }}</strong>
      </rt-checkbox>
      <span>{{ 'tlc.members.add_member.form.send_invitation_text' | translate }}</span>
    </div>
  </form>
</rt-dialog-body>
<rt-dialog-footer variant="white">
  <rt-button (click)="close()" variant="plain">{{ 'tlc.common.cancel' | translate }}</rt-button>
  <rt-button
    (click)="submit()"
    [disabled]="formGroup.invalid"
    [loading]="loading$()"
    variant="primary"
    >{{ 'tlc.members.add_member.add_member_cta' | translate: { count: members.length } }}</rt-button
  >
</rt-dialog-footer>

<ng-template #simpleViewTpl>
  @if (brand === TellentBrand.Recruitee) {
    <rt-form-field>
      <rt-label margin-top>{{ 'tlc.members.add_member.roles.role_label' | translate }}</rt-label>
      <rt-select
        [formControl]="seats.recruitee.controls.roleExternalId"
        [options]="this.recruiteeSelectOptions()"
        [emptyOptionValue]="'-'"
        [emptyOptionLabel]="'-'"
      />
    </rt-form-field>
  }
  @if (brand === TellentBrand.Kiwi) {
    <rt-form-field>
      <rt-label margin-top>{{ 'tlc.members.add_member.roles.role_label' | translate }}</rt-label>
      <rt-select
        [formControl]="seats.kiwi.controls.roleExternalId"
        [options]="this.kiwiSelectOptions()"
        [emptyOptionValue]="'-'"
        [emptyOptionLabel]="'-'"
      />
    </rt-form-field>
  }
</ng-template>
<ng-template #complexViewTpl>
  <rt-divider />
  <div class="access-roles">
    <div class="text">
      <rt-heading> {{ 'tlc.members.add_member.roles.heading' | translate }} </rt-heading>
      <span [innerHTML]="'tlc.members.add_member.roles.subheading' | translate"></span>
    </div>

    <tlc-access-roles-table
      [recruiteeFormGroup]="seats.recruitee"
      [kiwiFormGroup]="seats.kiwi"
    ></tlc-access-roles-table>
  </div>
</ng-template>
